import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-stockreport',
  templateUrl: './stockreport.component.html',
  styleUrls: ['./stockreport.component.scss']
})
export class StockreportComponent implements OnInit {

  public fromDate: string = '';
  public toDate: string = '';

  public StockReport_Row: any[] = [];

  constructor(public appservice: AppService) {}
public totalAmount: number = 0;
  ngOnInit(): void {}

  display() {

    if (!this.fromDate || !this.toDate) {
      alert("Please select From Date and To Date");
      return;
    }

    const date = this.fromDate.replace(/-/g,'');
    const tdate = this.toDate.replace(/-/g,'');

    const key = '';
    const type = 'P';
    const branch = 0;

    const url =
      `Api/transaction/get_stockReport?date=${date}&tdate=${tdate}&key=${key}&type=${type}&branch=${branch}`;

    this.appservice.get(url)
      .subscribe({

        next: (res:any) => {

          let parsed:any;

          try{
            parsed = typeof res === 'string' ? JSON.parse(res) : res;
          }
          catch{
            parsed = [];
          }

          if(!Array.isArray(parsed) && parsed?.record){
            parsed = parsed.record;
          }

          this.StockReport_Row = Array.isArray(parsed) ? parsed : [];
            this.totalAmount = this.StockReport_Row.reduce((sum, row) => {
            const profit = parseFloat(row['Stock Value']) || 0;
            return sum + profit;
          }, 0);
          if(!this.StockReport_Row.length){
            alert("No Data Found");
          }

        },

        error:(err)=>{

          console.error(err);
          this.StockReport_Row = [];
          alert("Error loading stock report");

        }

      });

  }

  export_excel(){

    if(!this.StockReport_Row?.length) return;

    this.appservice.Excel_Data.items = this.StockReport_Row;
    this.appservice.Excel_Data.Report_Name = 'Stock Report';
    this.appservice.Excel_Data.FileName = 'Stock_Report';

    this.appservice.export_excel();

  }

}